import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const categoryListApi = async (data) => {
  const endPoint = `/admin/categories?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add category------------------
export const addCategory = async (data) => {
  const endPoint = `/admin/categories`;
  return await axios.post(endPoint, data, setJwtToken());
};

// -----------image upload api

export const imgUploadToCloud = async (data) => {
  const endPoint = `/admin/uploads/images`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

// ------------------------fetch Selected category Detail------------------
export const fetchCategoryDetail = async (id) => {
  const endPoint = `/admin/categories/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------update Selected category Detail------------------
export const updateCategoryDetail = async ({ catUpdatedData, id }) => {
  const endPoint = `/admin/categories/${id}`;
  return await axios.put(endPoint, catUpdatedData, setJwtToken());
};

// ------------------------Delete Selected category ------------------
export const deleteCategory = async (id) => {
  const endPoint = `/admin/categories/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};

// ------------------------Change  Selected category STatus ------------------
export const changeCategoryStatus = async ({ id, status }) => {
  const endPoint = `/admin/categories/${id}`;
  return await axios.patch(endPoint, { status }, setJwtToken());
};
